export default function Brand({ size = "text-xl", className = "", textClass = "", iconClass = "h-9 w-9" }) {
  return (
    <span className={`inline-flex items-center gap-2 select-none ${className}`} data-testid="brand-logo">
      <img src="/jotprep-icon.png" alt="jotprep" className={`${iconClass} object-contain`} />
      <span className={`inline-flex items-baseline font-brand font-normal tracking-tight ${size} text-terra-500 ${textClass}`}>
        jot<span className="italic font-light text-[#D95228] tracking-normal -ml-0.5">prep</span>
        <span className="inline-block w-2 h-2 rounded-full bg-[#D95228] ml-1 shadow-sm" />
      </span>
    </span>
  );
}
